import api from "@/services/api";

export const state = {
  latestAssociations: [],
  associationsByYear: null,
  newAssociationsByYear: null,
  associationsByPlace: null,
  updatedAssociationsByYear: null,
  activityDistribution: null,
  representativesByYear: null,
};

export const mutations = {
  INIT_LATEST_ASSOCIATIONS(state, payload) {
    state.latestAssociations = payload;
  },
  INIT_ASSOCIATIONS_BY_YEAR(state, payload) {
    state.associationsByYear = payload;
  },
  INIT_NEW_ASSOCIATIONS_BY_YEAR(state, payload) {
    state.newAssociationsByYear = payload;
  },
  INIT_ASSOCIATIONS_BY_PLACE(state, payload) {
    state.associationsByPlace = payload;
  },
  INIT_UPDATED_ASSOCIATIONS_BY_YEAR(state, payload) {
    state.updatedAssociationsByYear = payload;
  },
  INIT_ACTIVITY_DISTRIBUTION(state, payload) {
    state.activityDistribution = payload;
  },
  INIT_REPRESENTATIVES_BY_YEAR(state, payload) {
    state.representativesByYear = payload;
  },
};

export const actions = {
  getLatestAssociations({ commit }) {
     api.getLatestAssociations().then((response) => {
      commit("INIT_LATEST_ASSOCIATIONS", response.data.data);
    });
  },
  getAssociationsByYear({ commit }) {
     api.getAssociationsByYear().then((response) => {
      commit("INIT_ASSOCIATIONS_BY_YEAR", response.data.data);
    });
  },
  getNewAssociationsByYear({ commit }) {
     api.getNewAssociationsByYear().then((response) => {
      commit("INIT_NEW_ASSOCIATIONS_BY_YEAR", response.data.data);
    });
  },
  getAssociationsByPlace({ commit }) {
     api.getAssociationsByPlace().then((response) => {
      commit("INIT_ASSOCIATIONS_BY_PLACE", response.data.data);
    });
  },
  getUpdatedAssociationsByYear({ commit }) {
     api.getUpdatedAssociationsByYear().then((response) => {
      commit("INIT_UPDATED_ASSOCIATIONS_BY_YEAR", response.data.data);
    });
  },
  getActivityDistribution({ commit }) {
     api.getActivityDistribution().then((response) => {
      commit("INIT_ACTIVITY_DISTRIBUTION", response.data.data);
    });
  },
  getRepresentativesByYear({ commit }) {
     api.getRepresentativesByYear().then((response) => {
      commit("INIT_REPRESENTATIVES_BY_YEAR", response.data.data);
    });
  },
}

export const getters = {
  getLatestAssociations: (state) => state.latestAssociations,
  getAssociationsByYear: (state) => state.associationsByYear,
  getNewAssociationsByYear: (state) => state.newAssociationsByYear,
  getAssociationsByPlace: (state) => state.associationsByPlace,
  getUpdatedAssociationsByYear: (state) => state.updatedAssociationsByYear,
  getActivityDistribution: (state) => state.activityDistribution,
  getRepresentativesByYear: (state) => state.representativesByYear,
};
